package org.hs_soft.runmynesto.domain.model.home.user.users_info

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import org.hs_soft.runmynesto.domain.model.general_error_model.GeneralError

@Serializable
data class UsersData(
    @SerialName("data")
    val data: Data?=null,
    @SerialName("errors")
    val errors: List<GeneralError?>?=null,
)

@Serializable
data class Data(
    val cashAssist: CashAssist?=null,
)

@Serializable
data class CashAssist(
    val listUsers: ListUsers?=null,
)
@Serializable
data class ListUsers(
    val items: List<UserModel>?=null,
)

@Serializable
data class UserModel(
    val id: String,
    val code: String ?=null,
    val name: String ?=null,
    val isActive:Boolean?=null,
)